import React from 'react';

import Layout from '../../components/Layout/Layout';
import Seo from '../../components/Seo';
import RequestDemo from '../../components/RequestDemo/RequestDemo';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

import SmallHero from '../../components/SmallHero/small-hero';

const RequestDemoPage = () => {
  const breadcrumbs = [
    {
      id: 'resources',
      name: 'Resources',
    },
    {
      id: 'request-a-demo',
      name: 'Request a Demo',
    },
  ];
  return (
    <Layout>
      <Seo
        title="Request a Demo | Integra Connect"
        description="Request a demo of Integra Connect's healthcare solutions today and discover how we can help your organization optimize performance and improve patient outcomes. Our team of experts is ready to answer your questions and show you our innovative, data-driven tools."
      />
      <SmallHero title="Learn How Integra Connect Can Help You Succeed with Value-Based, Precision Medicine. Book a demo to see what we can do for you">
        <Breadcrumb items={breadcrumbs} />
      </SmallHero>

      {/* Form Section */}
      <div className="mt-6">
        <RequestDemo />
      </div>
    </Layout>
  );
};

export default RequestDemoPage;
